module.exports = __webpack_public_path__ + "static/media/sd-card.28402674.svg";